<template>
  <div class="form_layout">
    <div class="form_outer"  :class="{'view':mode=='view'}">
      <div class="dialog_form_head" v-if="this.rediskey===null">
        产业用地调查
      </div>
      <div class="dialog_form">
        <el-form :model="addData" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div class="dialog_head">
          <span class="tit">产业用地调查</span>
          <el-date-picker
            :readonly="mode==='view'"
            v-model="addData.year"
            type="year"
            value-format="yyyy"
            placeholder="选择年"
            style="width:110px;">
          </el-date-picker>
          <span>
			    	（默认填写上一年度的数据调查）
			    </span>
        </div>
        <div class="d_content">
          <table border="0" cellspacing="0" cellpadding="0" class="table">
            <tr>
              <td colspan="4" class="td_title" style="border-top: 0;">
                <div>一、企业基本信息</div>
              </td>
            </tr>
            <tr>
              <td class="td_bg" width="140px">统一社会信用代码 <span style="color: red;font-weight: bold">*</span></td>
              <td>
                <el-form-item  prop="creditcode">
                <el-input v-model="addData.creditcode" :readonly="mode==='view'"></el-input>
                </el-form-item>
              </td>
              <td class="td_bg" width="140px">组织机构代码 <span style="color: red;font-weight: bold">*</span></td>
              <td>
                <el-form-item  prop="corpcode">
                <el-input v-model="addData.corpcode" :readonly="mode==='view'"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="td_bg">单位详细名称 <span style="color: red;font-weight: bold">*</span></td>
              <td colspan="3">
                <el-form-item  prop="cname">
                <el-input v-model="addData.cname" :readonly="mode==='view'"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="td_bg">企业简称</td>
              <td>
                <el-input v-model="addData.qyjc" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg">税号</td>
              <td>
                <el-input v-model="addData.tax_num" :readonly="mode==='view'"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">法定代表人</td>
              <td>
                <el-input v-model="addData.opername" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg">网址</td>
              <td>
                <el-input v-model="addData.corp_url" :readonly="mode==='view'"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">注册地址</td>
              <td>
                <el-input v-model="addData.address" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg">注册资本</td>
              <td>
                <el-input   oninput ="value=value.replace(/[^\d]/g,'')" v-model="addData.regzb" :readonly="mode==='view'"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">成立日期</td>
              <td>
                <el-date-picker
                  v-model="addData.startday"
                  :readonly="mode==='view'"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="width:180px;">
                </el-date-picker>
              </td>

              <td class="td_bg">经营地址</td>
              <td>
                <el-input v-model="addData.jyd_addr" :readonly="mode==='view'"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">行政联系人</td>
              <td>
                <el-input v-model="addData.lxr" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg">联系电话</td>
              <td>
                <el-input v-model="addData.lxrdh" :readonly="mode==='view'"></el-input>
              </td>
            </tr>

            <tr>
              <td class="td_bg">经营范围</td>
              <td colspan="3">
                <el-form-item  prop="corpscope">
                <el-input type="textarea" :rows="3" v-model="addData.corpscope" :readonly="mode==='view'"></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="td_bg">企业简介</td>
              <td colspan="3">
                <el-form-item  prop="intro">
                <el-input type="textarea" :rows="3" v-model="addData.intro" :readonly="mode==='view'"></el-input>
                </el-form-item>
              </td>
            </tr>

            <tr>
              <td colspan="4" class="td_title">
                <div>二、产业用地调查</div>
              </td>
            </tr>
            <tr>
              <td class="td_bg" width="140px">行业代码</td>
              <td>
                <el-input v-model="addData.tradecode" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg" width="140px">是否高新企业</td>
              <td>

                <el-select :readonly="mode==='view'" v-model="addData.is_gx" placeholder="请选择" @change="handleGXChange()" style="width:170px;">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </td>
            </tr>
            <tr>
              <td class="td_bg">期末从业人员</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^\d]/g,'')" v-model="addData.last_ry" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg">资产总计</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.total_zc" :readonly="mode==='view'"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">营业收入</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.yysr" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg">工业总产值</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.gypro" :readonly="mode==='view'"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">利润总额</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.lrze" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg">上缴税金</td>
              <td>
                <el-input placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')"  v-model="addData.sjsj" :readonly="mode==='view'"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">坐落地块</td>
              <td>
                <el-input v-model="addData.zl_plot" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg">企业占地面积</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="addData.zdmj" :readonly="mode==='view'"></el-input>
              </td>
            </tr>
            <tr>
              <td class="td_bg">企业租赁建筑面积</td>
              <td>
                <el-input  placeholder="请输入数字" oninput ="value=value.replace(/[^0-9.]/g,'')"  v-model="addData.znmj" :readonly="mode==='view'"></el-input>
              </td>
              <td class="td_bg"></td>
              <td>
                <el-input disabled :readonly="mode==='view'"></el-input>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="td_title">
                <div>三、附件上传</div>
              </td>
            </tr>
            <tr>
              <td class="td_bg">序号</td>
              <td class="td_bg">文件名称</td>
              <td class="td_bg text_center">上传时间</td>
              <td class="td_bg text_center">操作</td>
            </tr>
            <tr v-for="(item,index) in filesList">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td class="text_center">{{ item.create_time }}</td>
              <td>
                <div class="btn_outer text_center">
                  <el-button type="success" @click="downloadFile(item.filepath,item.name)" plain><i
                    class="cloudicon ci_download"></i>
                    下载
                  </el-button>
                  <el-button v-if="mode!=='view'"  type="danger" @click="del(index)" plain><i class="cloudicon ci_delect"></i>
                    删除
                  </el-button>
                </div>
              </td>
            </tr>
            <tr  v-if="mode!=='view'" >
              <td colspan="4">
                <div class="btn_outer text_right"  >
                  <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :on-exceed="handleExceed"
                    :http-request="htrupl"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                  </el-upload>
                  <!--<el-button type="primary" plain> <i class="cloudicon ci_upload"></i> <div>上传</div></el-button>-->
                </div>

              </td>
            </tr>
          </table>

        </div>
        </el-form>
        <div class="footer_btn"  v-if="mode!=='view'">
          <el-button type="primary"  @click="onSubmitAdd(2,'ruleForm')">提 交</el-button>
          <el-button @click="onSubmitAdd(1,'ruleForm')">暂 存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'editsurvey2',
  props: ['editId','mode'],
  data() {
    return {
      rediskey:null,
      filesList: [
        /* { name: 'xxx.jpg', createtime: '2020年09月18日'}*/
      ],
      btn_disabled1: false,
      btn_disabled2: false,
      addData: {
        year: null,
        pc_num: null,
        cname: null,
        qyjc: null,
        creditcode: null,
        corpcode: null,
        tax_num: null,
        qyxz: null,
        opername: null,
        corp_url: null,
        address: null,
        regzb: null,
        startday: null,
        jyd_addr: null,
        lxr: null,
        lxrdh: null,
        corpscope: null,
        intro: null,
        zdmj: null,
        znmj: null,
        tradecode: null,
        is_gx: null,
        last_ry: null,
        total_zc: null,
        yysr: null,
        gypro: null,
        lrze: null,
        sjsj: null,
        zl_plot: null,
        attachments: null,
        status: null
      },
      options: [{
        value: 1,
        label: '是'
      }, {
        value: 0,
        label: '否'
      }],
      rules: {
        creditcode: [
          {type: 'string', required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        corpcode: [
          {type: 'string', required: true, message: '请输入组织机构代码', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        cname: [
          {type: 'string', required: true, message: '请输入企业名称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        corpscope: [
          { min: 0, max: 600, message: '经营范围不能超过600字', trigger: 'blur' }
        ],
        intro: [
          { min: 0, max: 600, message: '企业简介不能超过600字', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    let redisKey= this.$route.query.rediskey;
    if(redisKey!==undefined && redisKey!==null){
      window.localStorage.setItem("gyzhqy_token",redisKey);
      let id= this.$route.query.id;
      let mode=this.$route.query.mode;
      this.editId=id;
      this.mode=mode;
      this.rediskey=redisKey;
    }
    this.getDcDetail();
  },
  methods: {
    async onSubmitAdd(status,formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitAdd(status);
        } else {

          setTimeout(()=>{
            var isError = document.getElementsByClassName("is-error");
            console.log(isError)
            var htmlInputElement = isError[0].querySelector('input');
            if(htmlInputElement) htmlInputElement.focus();

            var htmlAreaElement = isError[0].querySelector('textarea');
            if(htmlAreaElement) htmlAreaElement.focus();
          },100);
          // alert('error submit!!');
          return false;
        }
      });

    },

    async submitAdd(status) {
      this.addData.status = status;
      let data = this.addData;
      data.attachments=this.filesList.map(item=>item.id).join(',');
      this.btn_disabled1 = true;
      this.btn_disabled2 = true;
      let res = await this.$ajax.post(this.bUrl + 'api/portal/data/saveDc', data);
      if (res.data.code !== 200) {
        this.$message.error(res.data.msg);
      }else {
        this.$message.success(res.data.msg);
      }
      if (status === 2) {
        this.$emit('emitClose')
      }
      this.btn_disabled1 = false;
      this.btn_disabled2 = false;
    },

    async getDcDetail(){
      let res = await this.$ajax.get(this.bUrl + 'api/portal/data/detailDc?id='+this.editId);
    //  this.addData=res.data.data;
      for (let key in this.addData){
        if(key==='year'){
          this.addData[key]=res.data.data[key]+'';
        }else{
          this.addData[key]=res.data.data[key];
        }
      }
      this.filesList=res.data.data.attachments;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    htrupl(param) {
      let fileName = param.file.name.lastIndexOf(".");//取到文件名开始到最后一个点的长度
      let fileNameLength = param.file.name.length;//取到文件名长度
      let fileFormat = param.file.name.substring(fileName + 1, fileNameLength);//截
      const formData = new FormData()
      formData.append('file', param.file);
      this.$ajax.post(this.bUrl + 'api/portal/user/webuploader?_ajax=1&filetype=file', formData).then(function (res) {
        if (res.data.code === 200) {
          this.$message.success(res.data.msg);
          this.filesList.push(res.data.data);
        } else {
          this.$message.error(res.data.msg)
        }
      }.bind(this)).catch(function (error) {
        console.log(error);
      });
    },
    downloadFile(url,name) {
//    window.location.href = url;
      this.$down.download (url, name)
    },
    del(index) {
      this.filesList.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.mg1 {
  margin-bottom: 10px;
}

.mg2 {
  margin-top: 10px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/form/editsurvey2.vue